import colors from 'style-utils/colors';

const checkboxTheme = {
  checkbox: {
    label: {
      marginTop: '0',
      color: colors.midGrey,
      fontSize: '14px',
      fontFamily: 'var(--secondary-font-family), var(--primary-font-family)',
      fontWeight: 'bold',
      whiteSpace: 'initial',
      lineHeight: '16px',
    },
    root: {
      minHeight: '26px',
      lineHeight: '26px',
      margin: '',
      paddingLeft: '36px',

      tablet: {
        margin: '',
        paddingLeft: '36px',
      },
      desktop: {
        margin: '',
        paddingLeft: '44px',
      },
    },
    checkmark: {
      height: '26px',
      width: '26px',
      boxShadow: `inset 0 1px 3px 0 ${colors.checkboxShadow}`,
      border: `1px solid ${colors.checkboxBorder}`,
      borderRadius: '2px',
      checkedBorder: `1px solid ${colors.checkboxBorder}`,
      after: {
        height: '24px',
        width: '24px',
        backgroundSize: '16px 16px',
        image: '',
      },
    },
  },
};

export default checkboxTheme;
